import { faPlus, IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

interface EmptyContentProps {
  title: string
  description: string
  icon: IconDefinition
  btnText?: string
  btnAction?: () => void
}

const EmptyContent: React.FC<EmptyContentProps> = ({ title, description, icon, btnText, btnAction }) => (
  <div className="text-center">
    <FontAwesomeIcon size="4x" className="mx-auto text-gray-400" icon={icon} />
    <h3 className="mt-2 text-sm font-medium text-gray-900">{title}</h3>
    <p className="mt-1 text-sm text-gray-500">{description}</p>
    {btnAction && btnText && (
      <div className="mt-6">
        <button type="button" className="btn btn-white" onClick={btnAction}>
          <FontAwesomeIcon className="leading-icon" icon={faPlus} />
          {btnText}
        </button>
      </div>
    )}
  </div>
)

export default EmptyContent
